import React from 'react';
import { connect } from 'react-redux';
import { initHandler, ajaxViewHandler, ajaxHandler, setConfig } from '../../store/actions';
import { Row, Col, message } from 'antd';
import Config from '../../Config';
import { Helmet } from 'react-helmet';
import queryString from 'query-string';
import '../../assets/laporan.css';

const configClass = {
	title: 'LAPORAN STS EDC HARIAN',
	apiUrl: { preview: 'laporan/api/sts_harian/' },
};

class StsEdcHarianCetak extends React.Component {
	config;

	constructor(props) {
		super(props);
		this.config = new Config();
		this.state = {
			loading: false,
			data:    null,
			err:     false,
			tgl_dari: '',
		};
	}

	componentDidMount() {
		let uri_params = '';
		const uri_string = queryString.parse(this.props.location.search);
		for (const key in uri_string) {
			uri_params += (uri_params === '' ? '?' : '&') + key + '=' + uri_string[key];
			if (key === 'mulai_dari') this.setState({ tgl_dari: uri_string[key] });
		}
		this.preview(uri_params);
	}

	async preview(uri_params) {
		message.loading({ content: 'Menampilkan laporan STS EDC...', duration: 0, key: 'toast' });
		this.setState({ loading: true, err: false, data: null });
		this.props.ajaxViewHandler('get', configClass.apiUrl.preview + uri_params)
			.then(() => {
				const data = this.props.responseMsg;
				if (this.props.isSuccess) {
					message.destroy();
					this.setState({ loading: false, data, err: false });
					setTimeout(() => window.print(), 1300);
				} else {
					this.setState({ loading: false, data: null, err: true });
					message.error({ content: 'Gagal memuat laporan', duration: 2, key: 'toast' });
				}
			})
			.catch(() => {
				this.setState({ loading: false, data: null, err: true });
				message.error({ content: 'Gagal request data', duration: 2, key: 'toast' });
			});
	}

	render() {
		const { data, tgl_dari } = this.state;
		return (
			<>
				<Helmet>
					<title>{configClass.title}</title>
				</Helmet>

				{data !== null && data.map((item, idx) => (
					<div key={idx} className="kertas-laporan-a4">
						<div className="judul-laporan-sts" style={{ borderBottom: 'double 5px #000000', fontSize: 22 }}>
							<img src={this.config.get_site_info().logo_bw} style={{ height: 90 }} alt="logo" />
							PEMERINTAH PROPINSI KALIMANTAN TENGAH<br />
							SURAT TANDA SETORAN<br />
							(STS) EDC
						</div>

						<Row>
							<Col span={13} className="setoran-ke" style={{ fontSize: 16 }}>
								Setoran yang ke : {item.nomor_edc}
							</Col>
							<Col span={11} className="kepada" style={{ fontSize: 16 }}>
								<span className="samsat">{item.kabupaten}</span><br />
								Kas Daerah Propinsi Kalimantan Tengah<br />
								di. -<br />PALANGKARAYA
							</Col>
						</Row>

						<div className="deskripsi" style={{ fontSize: 16 }}>
							Harap Menerima Uang Sebesar : {(item.jumlah_edc || 0).toLocaleString('ID')}<br />
							{'# ' + this.config.pembilang(item.jumlah_edc || 0) + ' #'}<br />
							Yaitu Penerima : {item.akun_bank}
						</div>

						{(!item.data_edc || item.data_edc.length === 0) ? (
							<div style={{ padding: '12px 0', fontStyle: 'italic', fontSize: 14 }}>
								Tidak ada transaksi EDC pada tanggal ini.
							</div>
						) : (
							<>
								{item.data_edc.map((subItem, subIdx) => (
									<Row key={subIdx} style={{ fontSize: 16 }}>
										<Col span={5}>{subItem.nomor_rekening}</Col>
										<Col span={7}>{subItem.nama}</Col>
										<Col span={6} style={{ textAlign: 'right' }}>{subItem.jumlah} Unit</Col>
										<Col span={6} className="samsat" style={{ textAlign: 'right' }}>
											{subItem.total.toLocaleString('id')}
										</Col>
									</Row>
								))}
								<Row className="total-sts bold" style={{ fontSize: 16 }}>
									<Col span={6} offset={16} style={{ textAlign: 'right' }}>
										{(item.jumlah_edc || 0).toLocaleString('ID')}
									</Col>
								</Row>
							</>
						)}

						<br />

						{item.ttd !== undefined && (
							<Row justify="space-between" style={{ marginTop: 10, fontSize: 14 }}>
								<Col span={16} className="text-tengah" />
								<Col span={8} className="text-tengah">
									{item.kabupaten_asal}, TGL {tgl_dari}
								</Col>
								<Col span={8} className="teks-tengah">
									{item.ttd.ttd.kiri.jabatan}<br />
									<div style={{ marginTop: 50 }}>
										<b><u>{item.ttd.ttd.kiri.nama}</u></b><br />
										NIP : {item.ttd.ttd.kiri.nip}
									</div>
								</Col>
								<Col span={8} className="teks-tengah">
									{item.ttd.ttd.kanan.jabatan}<br />
									<div style={{ marginTop: 50 }}>
										<b><u>{item.ttd.ttd.kanan.nama}</u></b><br />
										NIP : {item.ttd.ttd.kanan.nip}
									</div>
								</Col>
								<Col span={8} className="teks-tengah" />
							</Row>
						)}
					</div>
				))}
			</>
		);
	}
}

const mapStateToProps = state => state.configReducers;

export default connect(
	mapStateToProps,
	{ initHandler, setConfig, ajaxViewHandler, ajaxHandler }
)(StsEdcHarianCetak);
